import { render, staticRenderFns } from "./ClassicConfiguration.vue?vue&type=template&id=c1be655e&"
import script from "./ClassicConfiguration.vue?vue&type=script&lang=ts&"
export * from "./ClassicConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports